var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("観光中に立ち寄り先を選択する際に、混雑している施設を避けることに心がけをしていますか？")]),_vm._v(" "),_c('SelectText',{attrs:{"item-list":_vm.lateList},on:{"select-text":_vm.onSelectText}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb981e12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organisms/InputLate.vue
// module id = null
// module chunks = 